import Event from "./GetEventMarsComplete.jsx/EventMarsComplete"
import useFormContext from "./GetEventMarsComplete.jsx/useFormMarsComplete"
import Schedule from "./GetEventMarsComplete.jsx/ScheduleMarsComplete"
import Guests from "./GetEventMarsComplete.jsx/GuestsMarsComplete"
import Summary from "./GetEventMarsComplete.jsx/SummaryMarsComplete"


const FormInputs = () => {

    const { page } = useFormContext()

    const display = {
        0: <Event />,
        1: <Schedule />,
        2: <Guests />,
        3: <Summary />
    }

    const content = (
        <>
            {display[page]}
        </>
    )


    return content
}
export default FormInputs